// Get File
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { MdClose, MdSettings } from "react-icons/md";
// import Jimp from "jimp/es";
import Jimp from "jimp/browser/lib/jimp";

import EventManager from "./EventManager";
import Queue, { states } from "./Queue";
import { CircleButton } from "./ui";

const StyledExport = styled.div`
  box-sizing: border-box;
  width: 32rem;
  background: #efefef;
  height: 100vh;
  padding: 6.4rem 4.8rem;
  border-left: 1px solid #ccc;
  position: absolute;
  bottom: 0;
  right: -32rem;
  z-index: 24;
  transition: right ease-in-out 0.16s;

  &.open {
    right: 0rem;
  }
`;

let _count = 0;

const type = "ExportMessage";

const extensions = {
  PNG: { mime: "image/png", ext: "png" },
  JPG: { mime: "image/jpeg", ext: "jpeg" }
};

const toJimpMime = (mime) => {
  if (mime === "image/jpeg") {
    return Jimp.MIME_JPEG;
  }

  if (mime === "image/png") {
    return Jimp.MIME_PNG;
  }
};

export const createExportMessage = (file, config = {}) => {
  if (!file) {
    throw new Error("No valid file");
  }

  if (config.crop.length !== 4) {
    throw new Error("No valid crop array length");
  }

  if (config.size.length !== 2) {
    throw new Error("No valid size array length");
  }

  return {
    type,
    file,
    config
  };
};

export default function Exporter() {
  const [settings, setSettings] = useState({
    quality: 72, // 0 - 1
    format: extensions.JPG,
    currentState: Queue.getState(),
    needsUpdate: false
  });

  const [showMenu, setShowMenu] = useState(false);

  const downloadFile = ({ data_uri, file, format }) => {
    const link = document.createElement("a");

    // Naming Convention
    link.download = `${file.name}_${file.type}_production.${format.ext}`;
    link.href = data_uri;
    link.click();
  };

  const processFile = (expMsg, onDone = () => {}) => {
    const { file, config } = expMsg;
    let { crop, size, source, mask, borderRadius } = config;

    const [x, y, w, h] = crop;
    const { width, height, name, type } = source;

    setSettings((state) => {
      // Force PNG
      const format = borderRadius[0] > 0 ? extensions.PNG : state.format;

      file.arrayBuffer().then((buffer) => {
        const image = Jimp.read(buffer);
        const maskImage = Jimp.read(mask);

        Promise.all([image, maskImage]).then((images) => {
          const i = images[0];
          const m = images[1];

          const wratio = i.bitmap.width / width;
          const hratio = i.bitmap.height / height;

          i.crop(x * wratio, y * hratio, w * wratio, h * hratio)
            .resize(...size)
            .mask(m, 0, 0)
            .quality(parseInt(state.quality, 10) || 100)
            .getBase64Async(toJimpMime(format.mime))
            .then((data_uri) => {
              onDone({
                file: {
                  name,
                  type
                },
                format,
                data_uri
              });
            })
            .catch((err) => {
              console.log(err);
            });
        });
      });
      return state;
    });
  };

  const exportFile = (expMsg) => {
    if (expMsg.type !== type) return;

    processFile(expMsg, downloadFile);
  };

  const exportCanvasToFile = (msg) => {
    const queue = [];

    // queue.push(process(msg));
    // queue.push(download(msg));

    const { target, data } = msg;

    download(target, settings, data);
  };

  const download = (
    canvas,
    settings,
    { type, filename = "fitxr_download" }
  ) => {
    console.log("downloading...");

    const link = document.createElement("a");

    // Naming Convention
    link.download = `${filename}_${type}_production.${settings.format.ext}`;
    link.href = canvas.toDataURL(settings.format.data, settings.quality);
    link.click();
  };

  const transitionState = (nextState) => {
    setSettings((state) => ({ ...state, currentState: nextState }));
  };

  const process = ({ from, target }) => {
    download(target, settings);

    if (Queue.isEmpty()) {
      transitionState(states.IDLE);
    }
  };

  const register = ({ id }) => {
    _count++;
    console.log("registered", id, _count);
  };

  const unregister = ({ id }) => {
    _count--;
    console.log("unregistered", id, _count);
  };

  const queue = (task) => {
    Queue.queue(task);
    setSettings((state) => ({ ...state, needsUpdate: true }));
  };

  const clear = () => {
    Queue.clear();
    setSettings((state) => ({ ...state, needsUpdate: true }));
  };

  // On Mount
  useEffect(() => {
    Queue.onEnqueue(process);

    // Setup events
    EventManager.on("queue", queue);
    EventManager.on("export", exportFile);

    EventManager.on("registerCanvas", register);
    EventManager.on("unregisterCanvas", unregister);

    return () => {
      EventManager.off("queue", Queue.queue);
      EventManager.off("export", exportFile);
      EventManager.off("registerCanvas", register);
      EventManager.off("unregisterCanvas", unregister);
    };
  }, []);

  return (
    <section>
      <CircleButton
        style={{ position: "fixed", right: "2.4rem", top: "2.4rem" }}
        onClick={() => {
          setShowMenu(true);
        }}
      >
        <MdSettings className="icon" />
      </CircleButton>
      <StyledExport className={showMenu ? "open" : ""}>
        {/* {Queue.getItems().map((task) => (
        <div key={task.id}>{`id: ${task.id}`}</div>
      ))} */}
        <CircleButton
          style={{ position: "absolute", right: "2.4rem", top: "2.4rem" }}
          onClick={() => {
            setShowMenu(false);
          }}
        >
          <MdClose className="icon" />
        </CircleButton>
        <h3>Quality: </h3>
        <input
          type="range"
          min="1"
          max="100"
          step="1"
          defaultValue={settings.quality}
          onChange={(e) => {
            setSettings((state) => ({ ...state, quality: e.target.value }));
          }}
        />
      </StyledExport>
    </section>
  );
}
